class AgeVerification {
	constructor(key = 'age_verified') {
		this.key = key;
		this.popup = document.getElementById('adults-only');
		this.init();
	}

	init() {
		// localStorage.removeItem(this.key)
		if (localStorage.getItem(this.key) !== 'confirmed') this.show();

		document.addEventListener('click', (e) => {
			if (e.target.closest('[data-adults-exit="false"]')) {
				e.preventDefault();
				localStorage.setItem(this.key, 'confirmed');
				this.hide();
			}
			if (e.target.closest('[data-adults-exit="true"]')) {
				e.preventDefault();
				window.history.length > 1 ? window.history.back() : window.close();
			}
		});
	}

	show() {
		this.popup?.classList.add('popup_show');
		document.documentElement.classList.add('popup-show');
	}

	hide() {
		document.activeElement?.blur();
		this.popup?.classList.remove('popup_show');
		document.documentElement.classList.remove('popup-show');
	}
}

document.addEventListener('DOMContentLoaded', () => new AgeVerification());